module.exports = __webpack_public_path__ + "img/Barlow-ExtraBold.57c8e00c.svg";